import { CoaterLicense } from '@workspace-app/odatabackend/QualicoatBackendModel';

export interface CoaterLicensePagination {
  currentPage: number;
  pageSize: number;
}

export interface CoaterLicenseFilter {
  coaterLicense: string | undefined;
  customerName: string | undefined;
  productionSiteName: string | undefined;
  coatingLineIdentifier: string | undefined;
}

export interface LicenseOrderBy {
  field: string | string[] | undefined;
  sortOrder: number | undefined;
}

export function convertToFilterString(filter: CoaterLicenseFilter) {
  const filters: string[] = [];

  if (filter.coaterLicense) {
    if (filter.coaterLicense.includes('-')) {
      const [prefix, sequenceNumber] = filter.coaterLicense.split('-');
      const subFilters: string[] = [];
      subFilters.push(`contains(tolower(LicensePrefix),tolower('${prefix}'))`);
      subFilters.push(`contains(cast(SequenceNumber, 'Edm.String'),'${sequenceNumber}')`);
      filters.push(`(${subFilters.join(' and ')})`);
    } else {
      const subFilters: string[] = [];
      subFilters.push(`contains(tolower(LicensePrefix),tolower('${filter.coaterLicense}'))`);
      subFilters.push(`contains(cast(SequenceNumber, 'Edm.String'),'${filter.coaterLicense}')`);
      filters.push(`(${subFilters.join(' or ')})`);
    }
  }
  if (filter.customerName) filters.push(`contains(tolower(customer/name),tolower('${filter.customerName}'))`);
  if (filter.productionSiteName)
    filters.push(`contains(tolower(productionSite/name),tolower('${filter.productionSiteName}'))`);
  if (filter.coatingLineIdentifier)
    filters.push(`contains(tolower(coatingLine/identifier),tolower('${filter.coatingLineIdentifier}'))`);

  return filters.join(' and ');
}

export function convertToOrderByString(orderBy: LicenseOrderBy) {
  const sortString = [];

  if (orderBy.field == 'licenseNumber') {
    sortString.push(`licensePrefix ${orderBy.sortOrder === 1 ? 'asc' : 'desc'}`);
    sortString.push(`sequenceNumber ${orderBy.sortOrder === 1 ? 'asc' : 'desc'}`);
  }
  if (orderBy.field == 'issueDate') sortString.push(`issueDate ${orderBy.sortOrder === 1 ? 'asc' : 'desc'}`);
  if (orderBy.field == 'customer') sortString.push(`customer/name ${orderBy.sortOrder === 1 ? 'asc' : 'desc'}`);
  if (orderBy.field == 'productionSite')
    sortString.push(`productionSite/name ${orderBy.sortOrder === 1 ? 'asc' : 'desc'}`);
  if (orderBy.field == 'coatingLine')
    sortString.push(`coatingLine/identifier ${orderBy.sortOrder === 1 ? 'asc' : 'desc'}`);

  return sortString.join(',');
}

export interface LicenseState {
  licenseNumbers: CoaterLicense[];
  licenseNumbersTotalCount: number;

  loading: boolean;
  saving: boolean;
  error: string | null;
  errorMessage: string | null;

  filter: CoaterLicenseFilter;
  orderBy: LicenseOrderBy;
  pagination: CoaterLicensePagination;
}

export const initialLicenseState: LicenseState = {
  licenseNumbers: [],
  licenseNumbersTotalCount: 0,

  loading: false,
  saving: false,
  error: null,
  errorMessage: null,

  pagination: { currentPage: 1 } as CoaterLicensePagination,
  filter: {} as CoaterLicenseFilter,
  orderBy: { field: 'issueDate', sortOrder: 1 } as LicenseOrderBy,
} as LicenseState;
